import { render, staticRenderFns } from "./PsPatientListDiseases.vue?vue&type=template&id=ed83bce2&scoped=true&"
import script from "./PsPatientListDiseases.vue?vue&type=script&lang=js&"
export * from "./PsPatientListDiseases.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientListDiseases.vue?vue&type=style&index=0&id=ed83bce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed83bce2",
  null
  
)

export default component.exports